import type { BusinessAccess } from "@payangel/shared";

export function intakeDepartment(team: string, access?: BusinessAccess | null) {
  if (access?.scope !== "department") return team;
  const match = access.departments.find(
    department => department.toLowerCase() === team.trim().toLowerCase(),
  );
  return match ?? (access.departments.length === 1 ? access.departments[0]! : "");
}
